import axios from ".";
/** Fetch a single employee by id. */
export const getEmployee = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/employees/${employeeId}`,
  });
};
